import { SHTable } from "@components/design-systems";
import { styled } from "@mui/material";
import { AnalysisSummaryStyleConfigs as Configs } from "../../../../configs";

export const AnalysisSummaryPortfolioDetailsTableWrapper = styled(SHTable)(
  ({ theme: { palette } }) => ({
    border: "none",
    tbody: {
      border: "none",
      tr: {
        border: `1px solid ${palette.secondary[100]}`,
        td: {
          fontSize: 14,
          minHeight: Configs.DefaultRowHeight,
          ":first-of-type": {
            fontWeight: 600,
            width: Configs.PortfolioDetailsTitleColumnWidth,
            borderRight: `1px solid ${palette.secondary[100]}`,
            backgroundColor: palette.common.white,
          },
          ":last-of-type": {
            backgroundColor: palette.secondary[50],
          },
        },
      },
    },
  }),
);
